export const SET_CURRENT_USER = 'setCurrentUser';

export const REGISTER = 'register';
export const GET_OTP = 'getOTP';
export const VERIFY_OTP = 'verifyOTP';

